import axios from "axios";
import { toast } from "react-toastify";
import {
  ProjectLOADING,
  ProjectERROR,
  ProjectListSUCCESS,
  ProjectCreateSUCCESS,
  ProjectUpdateSUCCESS,
  ProjectDeleteSUCCESS,
  ProjectFavoriteListSUCCESS,
  ProjectFavoriteAddSUCCESS,
  ProjectFavoriteRemoveSUCCESS,
} from "./Project.types";
import toastOptions from "../toastOptions";
import { translate, getStoredLocale } from "../../i18n/translate";

const ENDPOINT = `${process.env.REACT_APP_APIURL}/v1/organizations/`;

const authConfig = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

// The API hides archived projects by default (so the mobile and CLI pickers
// stay clean), but this UI wants them all: entries logged on an archived
// project still need its name and colour in lists, calendar chips and
// reports. The pickers filter them out instead, see common/activeProjects.
export const listProjectsApi = (orgId, token, includeArchived = true) => async (dispatch) => {
  dispatch({ type: ProjectLOADING });
  try {
    const query = includeArchived ? "?includeArchived=true" : "";
    const { data } = await axios.get(`${ENDPOINT}${orgId}/projects/${query}`, authConfig(token));
    dispatch({ type: ProjectListSUCCESS, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: ProjectERROR });
  }
};

export const createProjectApi = (orgId, clientId, name, color, dailyRate, subdivisions, token) => async (dispatch) => {
  dispatch({ type: ProjectLOADING });
  try {
    const { data } = await axios.post(
      `${ENDPOINT}${orgId}/clients/${clientId}/projects/`,
      { name, color, dailyRate, subdivisions },
      authConfig(token)
    );
    dispatch({ type: ProjectCreateSUCCESS, payload: data });
    toast.success(translate(getStoredLocale(), "toasts.projectCreated"), toastOptions);
    return data;
  } catch (e) {
    dispatch({ type: ProjectERROR });
    throw e;
  }
};

export const updateProjectApi = (orgId, projectId, clientId, name, color, dailyRate, subdivisions, token) => async (dispatch) => {
  dispatch({ type: ProjectLOADING });
  try {
    const { data } = await axios.put(
      `${ENDPOINT}${orgId}/projects/${projectId}`,
      { clientId, name, color, dailyRate, subdivisions },
      authConfig(token)
    );
    dispatch({ type: ProjectUpdateSUCCESS, payload: data });
    toast.success(translate(getStoredLocale(), "toasts.projectUpdated"), toastOptions);
    return data;
  } catch (e) {
    dispatch({ type: ProjectERROR });
    throw e;
  }
};

export const archiveProjectApi = (orgId, projectId, archived, token) => async (dispatch) => {
  dispatch({ type: ProjectLOADING });
  try {
    const { data } = await axios.put(
      `${ENDPOINT}${orgId}/projects/${projectId}/archive`,
      { archived },
      authConfig(token)
    );
    dispatch({ type: ProjectUpdateSUCCESS, payload: data });
    const key = archived ? "toasts.projectArchived" : "toasts.projectUnarchived";
    toast.success(translate(getStoredLocale(), key), toastOptions);
    return data;
  } catch (e) {
    dispatch({ type: ProjectERROR });
    throw e;
  }
};

// The favorite calls skip ProjectLOADING on purpose: they run alongside the
// project list and must not put the pages watching isLoading into a spinner.
export const listFavoritesApi = (orgId, token) => async (dispatch) => {
  try {
    const { data } = await axios.get(`${ENDPOINT}${orgId}/projects/favorites`, authConfig(token));
    dispatch({ type: ProjectFavoriteListSUCCESS, payload: data.projectIds || [] });
  } catch (e) {
    dispatch({ type: ProjectERROR });
  }
};

// Starring and unstarring update the store first so the star flips under the
// cursor, and put it back if the server refuses.
export const favoriteProjectApi = (orgId, projectId, token) => async (dispatch) => {
  dispatch({ type: ProjectFavoriteAddSUCCESS, payload: projectId });
  try {
    await axios.put(`${ENDPOINT}${orgId}/projects/${projectId}/favorite`, null, authConfig(token));
  } catch (e) {
    dispatch({ type: ProjectFavoriteRemoveSUCCESS, payload: projectId });
    dispatch({ type: ProjectERROR });
  }
};

export const unfavoriteProjectApi = (orgId, projectId, token) => async (dispatch) => {
  dispatch({ type: ProjectFavoriteRemoveSUCCESS, payload: projectId });
  try {
    await axios.delete(`${ENDPOINT}${orgId}/projects/${projectId}/favorite`, authConfig(token));
  } catch (e) {
    dispatch({ type: ProjectFavoriteAddSUCCESS, payload: projectId });
    dispatch({ type: ProjectERROR });
  }
};

export const deleteProjectApi = (orgId, projectId, token) => async (dispatch) => {
  dispatch({ type: ProjectLOADING });
  try {
    await axios.delete(`${ENDPOINT}${orgId}/projects/${projectId}`, authConfig(token));
    dispatch({ type: ProjectDeleteSUCCESS, payload: projectId });
    toast.success(translate(getStoredLocale(), "toasts.projectDeleted"), toastOptions);
  } catch (e) {
    dispatch({ type: ProjectERROR });
    throw e;
  }
};
